// Mock data for Zen Tech Services website

export const heroSlides = [
  {
    id: 1,
    title: "Transform Your Business with",
    highlight: "Intelligent Automation & Cloud Solutions",
    description: "Empowering enterprises with cutting-edge technology solutions in algo trading, AWS cloud infrastructure, and contact center automation.",
    cta: "Discover Our Solutions",
    ctaLink: "/services",
    image: "https://images.unsplash.com/photo-1597733336794-12d05021d510"
  },
  {
    id: 2,
    title: "Elevate Your Trading with",
    highlight: "Algorithm-Based Trading Automation",
    description: "Harness the power of advanced algorithms to optimize your trading strategies and maximize returns with our proven automation solutions.",
    cta: "Explore Trading Solutions",
    ctaLink: "/services",
    image: "https://images.unsplash.com/photo-1600132806370-bf17e65e942f"
  },
  {
    id: 3,
    title: "Scale Your Business with",
    highlight: "AWS Cloud Excellence",
    description: "From migration to optimization, we deliver comprehensive AWS cloud solutions that drive efficiency, scalability, and innovation.",
    cta: "Get Started Today",
    ctaLink: "/contact",
    image: "https://images.unsplash.com/photo-1644316902396-9bd0558cd771"
  }
];

export const services = [
  {
    id: 1,
    title: "Algo-Based Trading Automation",
    description: "Advanced algorithmic trading systems designed to execute trades with precision and speed. Our solutions leverage machine learning and quantitative analysis to optimize trading strategies.",
    icon: "TrendingUp",
    image: "https://images.unsplash.com/photo-1768323275769-6615e7cfcbe4",
    features: ["Real-time market analysis", "Risk management systems", "Backtesting & optimization", "Multi-asset support"]
  },
  {
    id: 2,
    title: "AWS & Azure Cloud Solutions",
    description: "Comprehensive cloud services for AWS and Azure including migration, infrastructure setup, optimization, and ongoing management. Build scalable, secure, and cost-effective multi-cloud architectures.",
    icon: "Cloud",
    image: "https://images.pexels.com/photos/5480781/pexels-photo-5480781.jpeg",
    features: ["Multi-cloud migration (AWS/Azure)", "Infrastructure as Code", "DevOps implementation", "Cost optimization"]
  },
  {
    id: 3,
    title: "Contact Center Automation",
    description: "Transform customer interactions with Amazon Connect and telephony platforms like Twilio and SignalWire. Deliver exceptional customer experiences through intelligent automation.",
    icon: "Phone",
    image: "https://images.pexels.com/photos/5203849/pexels-photo-5203849.jpeg",
    features: ["Amazon Connect setup", "IVR automation", "Call routing & analytics", "Multi-channel support"]
  },
  {
    id: 4,
    title: "Web & Mobile Development",
    description: "Custom web and iOS applications built with modern technologies like React and Java. From concept to deployment, we create scalable, enterprise-grade applications that drive business growth.",
    icon: "Code",
    image: "https://images.unsplash.com/photo-1761195696590-3490ea770aa1",
    features: ["React web applications", "Java enterprise solutions", "iOS native development", "RESTful API development"]
  }
];

export const technologies = [
  { name: "AWS", category: "Cloud" },
  { name: "Azure", category: "Cloud" },
  { name: "Amazon Connect", category: "Contact Center" },
  { name: "Twilio", category: "Telephony" },
  { name: "SignalWire", category: "Telephony" },
  { name: "React", category: "Frontend" },
  { name: "Java", category: "Backend" },
  { name: "Spring Boot", category: "Backend" },
  { name: "Node.js", category: "Backend" },
  { name: "Python", category: "Backend" },
  { name: "Swift", category: "Mobile" },
  { name: "TensorFlow", category: "AI/ML" },
  { name: "Docker", category: "DevOps" },
  { name: "Kubernetes", category: "DevOps" },
  { name: "PostgreSQL", category: "Database" },
  { name: "MongoDB", category: "Database" }
];

export const caseStudies = [
  {
    id: 1,
    title: "AI-Powered Legal Call Center for US Law Firm",
    client: "US Personal Injury Law Firm",
    description: "Revolutionized client intake process with an AI-powered voice system that handles compensation cases including accidents, dog bites, and injury claims. The system communicates naturally like a human, collecting critical case information and seamlessly transferring to human agents when needed.",
    challenge: "Law firm receiving hundreds of daily calls for compensation cases (accidents, injuries, dog bites) needed efficient client intake while maintaining personal touch. Manual handling led to missed calls, inconsistent data collection, and high operational costs.",
    solution: "Designed and deployed an intelligent conversational AI system on Amazon Connect that answers toll-free calls, conducts natural human-like conversations, collects comprehensive case details, qualifies leads, and transfers to human agents only when necessary.",
    results: ["90% of calls handled entirely by AI without human intervention", "24/7 availability with zero missed calls", "70% reduction in operational costs", "Consistent data collection with 95% accuracy"],
    technologies: ["Amazon Connect", "AWS Lex", "AWS Lambda", "Amazon Polly", "DynamoDB", "Python"],
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f"
  },
  {
    id: 2,
    title: "Automated Trading Strategy System",
    client: "Proprietary Trading Firm",
    description: "Developed a fully automated algorithmic trading system with custom strategies that executes buy and sell orders without human intervention, operating 24/7 based on real-time market analysis and predefined rules.",
    challenge: "Trading firm needed to execute complex trading strategies consistently without emotional bias, capture opportunities in volatile markets, and operate continuously across multiple time zones.",
    solution: "Built custom algorithmic trading system with proprietary strategies coded in Python, integrated with multiple exchanges, featuring risk management, real-time analytics, backtesting capabilities, and automatic order execution.",
    results: ["100% automated execution with zero human intervention", "24/7 trading across global markets", "35% improvement in strategy performance", "Eliminated emotional trading decisions"],
    technologies: ["Python", "Pandas", "NumPy", "AWS", "Redis", "PostgreSQL", "WebSocket"],
    image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3"
  },
  {
    id: 3,
    title: "Multi-Cloud Enterprise Migration",
    client: "E-commerce Company",
    description: "Migrated on-premise infrastructure to hybrid AWS and Azure cloud, resulting in 60% cost reduction and improved scalability.",
    challenge: "Legacy infrastructure limiting scalability and increasing operational costs",
    solution: "Hybrid cloud migration with AWS and Azure, microservices architecture, and auto-scaling",
    results: ["60% reduction in infrastructure costs", "3x improvement in performance", "99.99% uptime achieved"],
    technologies: ["AWS", "Azure", "Kubernetes", "Docker", "Terraform"],
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa"
  },
  {
    id: 4,
    title: "Contact Center Digital Transformation",
    client: "Telecom Provider",
    description: "Implemented Amazon Connect with AI-powered routing, handling 10,000+ daily calls with improved customer satisfaction.",
    challenge: "Outdated phone systems causing poor customer experience and high operational costs",
    solution: "Amazon Connect implementation with intelligent call routing and analytics",
    results: ["40% improvement in customer satisfaction", "50% reduction in wait times", "30% cost savings"],
    technologies: ["Amazon Connect", "Twilio", "AWS Lambda", "DynamoDB"],
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7"
  },
  {
    id: 5,
    title: "Enterprise Java Application Modernization",
    client: "Financial Services Corporation",
    description: "Modernized legacy Java application to Spring Boot microservices on Azure, improving performance and reducing maintenance costs by 50%.",
    challenge: "Monolithic Java application causing deployment bottlenecks and high maintenance overhead",
    solution: "Refactored to Spring Boot microservices architecture deployed on Azure Kubernetes Service with CI/CD pipelines",
    results: ["50% reduction in maintenance costs", "70% faster deployment cycles", "Enhanced system reliability and scalability"],
    technologies: ["Java", "Spring Boot", "Azure", "Kubernetes", "React"],
    image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c"
  }
];

export const projects = [
  {
    id: 1,
    title: "AI Legal Call Center System",
    category: "Contact Center",
    description: "Human-like AI voice system for US law firm handling compensation cases with 90% automation rate",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f"
  },
  {
    id: 2,
    title: "Automated Trading Strategy Platform",
    category: "Algo Trading",
    description: "Fully automated trading system executing buy/sell orders 24/7 without human intervention",
    image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3"
  },
  {
    id: 3,
    title: "Real-Time Trading Dashboard",
    category: "Algo Trading",
    description: "Advanced trading platform with real-time analytics and automated execution",
    image: "https://images.unsplash.com/photo-1642790106117-e829e14a795f"
  },
  {
    id: 4,
    title: "AWS Cloud Infrastructure Management",
    category: "AWS Cloud",
    description: "Scalable AWS cloud solution for enterprise resource management",
    image: "https://images.unsplash.com/photo-1639322537228-f710d846310a"
  },
  {
    id: 5,
    title: "Azure DevOps Platform",
    category: "Azure Cloud",
    description: "Complete CI/CD pipeline on Azure with automated deployments",
    image: "https://images.unsplash.com/photo-1667372393119-3d4c48d07fc9"
  },
  {
    id: 6,
    title: "Omnichannel Contact Center",
    category: "Contact Center",
    description: "Integrated communication platform with AI-powered routing",
    image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3"
  },
  {
    id: 5,
    title: "Enterprise Java Banking System",
    category: "Java Development",
    description: "Secure banking application built with Java Spring Boot and microservices",
    image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3"
  },
  {
    id: 6,
    title: "React E-Commerce Platform",
    category: "React Development",
    description: "Modern e-commerce web application with React and real-time inventory",
    image: "https://images.unsplash.com/photo-1557821552-17105176677c"
  },
  {
    id: 7,
    title: "E-Commerce Mobile App",
    category: "Mobile Development",
    description: "Feature-rich iOS shopping application with seamless UX",
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c"
  },
  {
    id: 8,
    title: "Financial Analytics Dashboard",
    category: "React Development",
    description: "React-based dashboard for real-time financial data visualization",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f"
  },
  {
    id: 9,
    title: "Java Microservices API Gateway",
    category: "Java Development",
    description: "Scalable API gateway built with Spring Cloud on Azure",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31"
  },
  {
    id: 10,
    title: "Voice-Enabled Customer Service",
    category: "Automation",
    description: "AI-powered voice assistant for customer support",
    image: "https://images.unsplash.com/photo-1589254065878-42c9da997008"
  },
  {
    id: 11,
    title: "Azure Cloud Data Lake",
    category: "Azure Cloud",
    description: "Big data analytics platform on Azure with machine learning integration",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71"
  },
  {
    id: 12,
    title: "React Admin Dashboard",
    category: "React Development",
    description: "Comprehensive admin panel with React, Redux, and real-time updates",
    image: "https://images.unsplash.com/photo-1551650975-87deedd944c3"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Proven Expertise",
    description: "Years of experience delivering complex technology solutions across trading, cloud, and automation domains.",
    icon: "Award"
  },
  {
    id: 2,
    title: "Innovation-Driven",
    description: "We stay ahead of technology trends to provide cutting-edge solutions that give you a competitive advantage.",
    icon: "Lightbulb"
  },
  {
    id: 3,
    title: "Client-Centric Approach",
    description: "Your success is our priority. We work closely with you to understand and exceed your business objectives.",
    icon: "Users"
  },
  {
    id: 4,
    title: "End-to-End Solutions",
    description: "From consulting to implementation and support, we provide comprehensive solutions for all your IT needs.",
    icon: "CheckCircle"
  }
];

export const stats = [
  { label: "Project Success Rate", value: "100%", icon: "Trophy" },
  { label: "Technologies Mastered", value: "15+", icon: "Code" },
  { label: "Industries Served", value: "Multiple", icon: "Briefcase" },
  { label: "Client Satisfaction", value: "100%", icon: "Smile" }
];
